// extracted by mini-css-extract-plugin
export default {"splash":"Splash_splash__VzVuY"};